(function () {
  var LOG = '[cnpj-validation]';

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.warn.apply(console, args);
  }

  function errorLog() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.error.apply(console, args);
  }

  function boot() {
    var root = document.querySelector('[data-cnpj-validation]');
    if (!root) {
      warn('section [data-cnpj-validation] nao encontrada');
      return;
    }
    if (root.getAttribute('data-cnpj-booted') === 'true') return;
    root.setAttribute('data-cnpj-booted', 'true');

    var API_URL = (root.getAttribute('data-api-url') || '').trim();
    var MSG_INVALID = root.getAttribute('data-msg-invalid') || 'CNPJ invalido. Verifique os dados informados.';
    var MSG_EXISTS = root.getAttribute('data-msg-exists') || 'Este CNPJ ja possui cadastro ativo no sistema.';
    var MSG_CHECKING = root.getAttribute('data-msg-checking') || 'Verificando CNPJ...';
    var MSG_API_ERROR = root.getAttribute('data-msg-api-error') || 'Nao foi possivel verificar o CNPJ no momento.';
    var MSG_NO_FIELD = 'Campo CNPJ nao encontrado no formulario. Nao e possivel enviar.';
    var msgEl = root.querySelector('[id^="cnpj-validation-msg-"]');
    var verifying = false;

    log('boot', { API_URL: API_URL || '(vazio)' });

    function digitsOnly(value) {
      return String(value || '').replace(/[^\d]/g, '');
    }

    function validateCNPJ(value) {
      var cnpj = digitsOnly(value);
      if (cnpj.length !== 14) return false;
      if (/^(\d)\1+$/.test(cnpj)) return false;

      var sum = 0;
      var w = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      for (var i = 0; i < 12; i++) sum += parseInt(cnpj[i], 10) * w[i];
      var r = sum % 11;
      var d1 = r < 2 ? 0 : 11 - r;
      if (parseInt(cnpj[12], 10) !== d1) return false;

      sum = 0;
      w = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      for (var j = 0; j < 13; j++) sum += parseInt(cnpj[j], 10) * w[j];
      r = sum % 11;
      var d2 = r < 2 ? 0 : 11 - r;
      return parseInt(cnpj[13], 10) === d2;
    }

    function textLooksLikeCnpjLabel(text) {
      var t = String(text || '').toLowerCase();
      return (
        t.indexOf('cnpj') !== -1 ||
        t.indexOf('c.n.p.j') !== -1 ||
        t.indexOf('tax id') !== -1 ||
        t.indexOf('id fiscal') !== -1 ||
        t.indexOf('documento') !== -1
      );
    }

    function findCNPJInput(form) {
      if (!form) return null;

      var byTestId = form.querySelector(
        '[data-testid*="cnpj"], [data-testid*="CNPJ"], [name*="cnpj"], [name*="CNPJ"], [id*="cnpj"], [id*="CNPJ"]'
      );
      if (byTestId && byTestId.tagName === 'INPUT') {
        log('campo via testid/name/id', byTestId);
        return byTestId;
      }

      var inputs = form.querySelectorAll('input[type="text"], input[type="tel"], input[type="number"], input:not([type])');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        var blob = [
          el.id,
          el.name,
          el.placeholder,
          el.getAttribute('aria-label'),
          el.getAttribute('data-testid'),
          el.getAttribute('autocomplete'),
        ]
          .join(' ')
          .toLowerCase();

        if (textLooksLikeCnpjLabel(blob)) {
          log('campo via atributos', el, blob);
          return el;
        }

        // valor ja preenchido com 14 digitos
        if (digitsOnly(el.value).length === 14) {
          log('campo via valor 14 digitos', el);
          return el;
        }
      }

      var rootNode = form.getRootNode ? form.getRootNode() : document;
      var labeled = form.querySelectorAll('[aria-labelledby]');
      for (var j = 0; j < labeled.length; j++) {
        var labelId = labeled[j].getAttribute('aria-labelledby');
        var labelEl =
          labelId && rootNode.getElementById
            ? rootNode.getElementById(labelId)
            : labelId
              ? document.getElementById(labelId)
              : null;
        if (labelEl && textLooksLikeCnpjLabel(labelEl.textContent)) {
          log('campo via aria-labelledby', labeled[j]);
          return labeled[j];
        }
      }

      var labels = form.querySelectorAll('label');
      for (var k = 0; k < labels.length; k++) {
        if (!textLooksLikeCnpjLabel(labels[k].textContent)) continue;
        var forId = labels[k].getAttribute('for');
        if (forId) {
          var byFor =
            (rootNode.getElementById && rootNode.getElementById(forId)) ||
            document.getElementById(forId);
          if (byFor) {
            log('campo via label[for]', byFor);
            return byFor;
          }
        }
        var nested = labels[k].querySelector('input');
        if (nested) {
          log('campo via label nested', nested);
          return nested;
        }
      }

      warn('nenhum campo CNPJ encontrado no form', form);
      return null;
    }

    function showError(msg) {
      if (!msgEl) {
        warn('msgEl ausente:', msg);
        return;
      }
      msgEl.textContent = msg;
      msgEl.classList.remove('is-info');
      msgEl.classList.add('is-error');
    }

    function showInfo(msg) {
      if (!msgEl) return;
      msgEl.textContent = msg;
      msgEl.classList.remove('is-error');
      msgEl.classList.add('is-info');
    }

    function clearError() {
      if (!msgEl) return;
      msgEl.textContent = '';
      msgEl.classList.remove('is-error', 'is-info');
    }

    function findSubmitButtons(form) {
      return form.querySelectorAll(
        '[type="submit"], button:not([type]), [data-testid*="submit" i], [class*="Submit"]'
      );
    }

    function setSubmitLoading(form, loading) {
      var buttons = findSubmitButtons(form);
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        if (loading) {
          if (!btn.getAttribute('data-cnpj-original-text')) {
            btn.setAttribute('data-cnpj-original-text', btn.textContent);
          }
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = MSG_CHECKING;
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          var orig = btn.getAttribute('data-cnpj-original-text');
          if (orig !== null) btn.textContent = orig;
        }
      }
    }

    function verifyCNPJExists(cnpj) {
      if (!API_URL) return Promise.reject(new Error('API URL nao configurada'));
      var digits = digitsOnly(cnpj);
      var separator = API_URL.indexOf('?') === -1 ? '?' : '&';
      var url = API_URL + separator + 'cnpj=' + encodeURIComponent(digits);
      var started = Date.now();

      log('GET', url);

      return fetch(url, { method: 'GET', credentials: 'omit' })
        .then(function (res) {
          log('status', res.status, 'em', Date.now() - started, 'ms');
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          log('resposta API', data);
          return data;
        });
    }

    function allowSubmit(form) {
      log('liberando envio do formulario');
      form.setAttribute('data-cnpj-verified', 'true');
      verifying = false;
      var submitBtn = form.querySelector('[type="submit"], button:not([type])');
      if (submitBtn) submitBtn.click();
      else if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    function runValidation(e, form) {
      log('interceptando envio');

      if (form.getAttribute('data-cnpj-verified') === 'true') {
        log('ja verificado — deixa passar');
        form.removeAttribute('data-cnpj-verified');
        return;
      }

      // SEMPRE bloqueia ate validar
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (verifying) {
        warn('ja existe verificacao em andamento');
        return;
      }

      var input = findCNPJInput(form);
      clearError();

      if (!input) {
        errorLog('bloqueado: campo CNPJ nao encontrado');
        showError(MSG_NO_FIELD);
        return;
      }

      var raw = input.value;
      var digits = digitsOnly(raw);
      log('valor CNPJ', { raw: raw, digits: digits, len: digits.length });

      if (!validateCNPJ(raw)) {
        warn('CNPJ invalido (digitos/check)');
        showError(MSG_INVALID);
        return;
      }

      if (!API_URL) {
        errorLog('API_URL vazia');
        showError(MSG_API_ERROR);
        return;
      }

      verifying = true;
      showInfo(MSG_CHECKING);
      setSubmitLoading(form, true);

      verifyCNPJExists(raw)
        .then(function (data) {
          verifying = false;
          setSubmitLoading(form, false);

          var exists = !!(data && (data.exists || data.found || data.cadastrado));
          log('exists?', exists, data);

          if (exists) {
            warn('BLOQUEADO — CNPJ ja cadastrado', data.match || data);
            showError(MSG_EXISTS);
            return;
          }

          log('CNPJ livre — liberando submit');
          clearError();
          allowSubmit(form);
        })
        .catch(function (err) {
          verifying = false;
          setSubmitLoading(form, false);
          errorLog('falha na API — BLOQUEANDO envio', err);
          showError(MSG_API_ERROR);
        });
    }

    function attachToForm(form) {
      if (!form || form._cnpjHooked) return;
      form._cnpjHooked = true;
      log('hook no form', form);

      form.addEventListener(
        'submit',
        function (e) {
          runValidation(e, form);
        },
        true
      );

      // Shopify Forms muitas vezes dispara por click no botao
      findSubmitButtons(form).forEach(function (btn) {
        if (btn._cnpjClickHooked) return;
        btn._cnpjClickHooked = true;
        btn.addEventListener(
          'click',
          function (e) {
            if (form.getAttribute('data-cnpj-verified') === 'true') return;
            log('click no botao submit');
            runValidation(e, form);
          },
          true
        );
      });
    }

    function watchScope(scope) {
      if (!scope || !scope.querySelector) return;
      var form = scope.querySelector('form');
      if (form) attachToForm(form);

      if (typeof MutationObserver === 'undefined') return;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'FORM') attachToForm(node);
            else if (node.querySelector) {
              var f = node.querySelector('form');
              if (f) attachToForm(f);
              node.querySelectorAll('shopify-forms-embed').forEach(watchEmbed);
            }
            if (node.tagName === 'SHOPIFY-FORMS-EMBED') watchEmbed(node);
          });
        });
      }).observe(scope, { childList: true, subtree: true });
    }

    function watchEmbed(embedEl) {
      if (!embedEl || embedEl._cnpjWatched) return;
      embedEl._cnpjWatched = true;
      log('watch shopify-forms-embed', embedEl);

      function attachShadow() {
        var scope = embedEl.shadowRoot || embedEl;
        log('shadowRoot?', !!embedEl.shadowRoot);
        watchScope(scope);
      }

      attachShadow();
      if (!embedEl.shadowRoot) {
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (embedEl.shadowRoot || tries > 60) {
            clearInterval(timer);
            attachShadow();
          }
        }, 200);
      }
    }

    watchScope(document.body);
    document.querySelectorAll('shopify-forms-embed').forEach(watchEmbed);
    document.querySelectorAll('[data-form-root], form').forEach(function (el) {
      if (el.tagName === 'FORM') attachToForm(el);
      else watchScope(el);
    });

    log('observer ativo');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
